import React from 'react';
import './HeroImage.less';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

export const HeroImage = ({src}) => {
	return (
		<div className="hero-image">
			<LazyLoadImage wrapperClassName="hero-image__image" effect="opacity" src={src} width="100%"/>
		</div>
	);
};
